import { fetchDestinations } from '../../api/travelCalcApi';

export const GET_ALL_DESTINATIONS = 'efes/travelCalc/GET_ALL_DESTINATIONS';
export const GET_ALL_DESTINATIONS_SUCCESS = 'efes/travelCalc/GET_ALL_DESTINATIONS_SUCCESS';
export const GET_ALL_DESTINATIONS_FAIL = 'efes/travelCalc/GET_ALL_DESTINATIONS_FAIL';

const initialState = {
  allDestinations: [],
  isFetchingDestinations: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_DESTINATIONS:
      return {
        ...state,
        isFetchingDestinations: true,
      };
    case GET_ALL_DESTINATIONS_SUCCESS:
      return {
        ...state,
        isFetchingDestinations: false,
        allDestinations: action.result,
      };
    case GET_ALL_DESTINATIONS_FAIL:
      return {
        ...state,
        isFetchingDestinations: false,
      };
    default:
      return state;
  }
}

export function loadAvailableDestinations() {
  return {
    actions: [
      { type: GET_ALL_DESTINATIONS },
      { type: GET_ALL_DESTINATIONS_SUCCESS },
      { type: GET_ALL_DESTINATIONS_FAIL, showError: true },
    ],
    promise: fetchDestinations(),
  };
}
